import SearchController from "../Search/SearchController";

function PatentSearch() {
  return <SearchController />;
}

export default PatentSearch;
